export default {
  label: {
    cancelLabel: 'Cancelar',
    cardLabel: 'Eliminar',
    modalTitle: 'Eliminar componente',
    modalText: '¿Está seguro de que desea eliminar el componente?',
  },
};
